import * as Popover from '@radix-ui/react-popover'
import { Link } from '@remix-run/react'
import {
	NodeViewContent,
	type NodeViewProps,
	NodeViewWrapper,
} from '@tiptap/react'
import { ChevronDown } from 'lucide-react'
import { Button } from '#app/components/ui/button.js'
import { Input } from '#app/components/ui/input.js'
import { type CustomizerData } from '#app/utils/customizer.client.js'

const variables = {
	none: 'Custom link',
	verificationLink: 'Verification link',
	subscriberLink: 'User link',
	referralLink: 'Referral link',
	projectLink: 'Project link',
}

export const Component = (props: NodeViewProps) => {
	const editable = props.editor.isEditable
	const align = props.node.attrs.align

	if (editable) {
		const handleLinkChange = (value: string) => {
			props.updateAttributes({
				link: value,
			})
		}

		const handleVariableChange = (value: string) => {
			props.updateAttributes({
				variable: value,
			})
		}

		return (
			<NodeViewWrapper>
				<div className="flex" style={{ justifyContent: align }}>
					<Popover.Root>
						<Popover.Trigger asChild>
							<div className="button-tt flex h-[45px] items-center px-4">
								<NodeViewContent />
							</div>
						</Popover.Trigger>
						<Popover.Portal>
							<Popover.Content
								className="custom-popover z-50 flex items-center gap-2 rounded-xl border border-border bg-white p-2 shadow-sm"
								sideOffset={8}
								onOpenAutoFocus={e => e.preventDefault()}
							>
								<div className="flex w-[156px] flex-col space-y-2">
									<div className="relative">
										<select
											name="variable"
											className="h-[32px] w-full appearance-none rounded-[8px] border border-border px-2 outline-none hover:outline-none active:outline-none"
											value={props.node.attrs.variable}
											onChange={e =>
												handleVariableChange(e.currentTarget.value)
											}
										>
											{Object.entries(variables).map(([value, name]) => (
												<option key={value} value={value}>
													{name}
												</option>
											))}
										</select>
										<ChevronDown
											className="pointer-events-none absolute inset-y-1 right-1.5"
											width={16}
										/>
									</div>
									{props.node.attrs.variable === 'none' && (
										<Input
											type="text"
											placeholder="https://"
											variant="s"
											value={props.node.attrs.link}
											onChange={e => handleLinkChange(e.currentTarget.value)}
										/>
									)}
								</div>
							</Popover.Content>
						</Popover.Portal>
					</Popover.Root>
				</div>
			</NodeViewWrapper>
		)
	} else {
		const variableId = props.node.attrs.variable
		const data = props.extension.options.data as CustomizerData
		const sub = data.sub
		const list = data.list
		let link = props.node.attrs.link

		switch (variableId) {
			case 'referralLink':
				link = sub?.referralLink
				break
			case 'verificationLink':
				link = sub?.verificationLink
				break
			case 'subscriberLink':
				link = sub?.subscriberLink
				break
			case 'projectLink':
				link = list?.projectLink
				break
		}

		if (link) {
			return (
				<NodeViewWrapper>
					<Button
						type="button"
						variant="customizer"
						className="button-tt !flex"
						asChild
					>
						<Link
							to={
								'https://' + link.replace('https://', '').replace('http://', '')
							}
							target="_blank"
						>
							<NodeViewContent />
						</Link>
					</Button>
				</NodeViewWrapper>
			)
		}
	}
}

export default Component
